import { IconProps } from "./IconProps";

export default function VoucherDisbursementIcon(props: IconProps) {
  return (
    <svg width={props.size || '22'} height={props.size || '22'} viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12.8334 8.24999L8.25002 3.66666M8.25002 3.66666L3.66669 8.24999M8.25002 3.66666V14.6667C8.25002 15.6391 8.63633 16.5717 9.32396 17.2594C10.0116 17.947 10.9442 18.3333 11.9167 18.3333H18.3334" stroke={props.color || '#fff'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
